<template>
  <div class="wrapper">
    <div class="card">
      <h3>{{ gradeName }}{{ className }}班知识点得分情况</h3>
      <div class="card-content">
        <div class="card-button">
          <el-button-group>
            <el-button type="primary" size="medium" :plain="!knowledgeActive" @click="knowledgeActive = true">图形</el-button>
            <el-button type="primary" size="medium" :plain="knowledgeActive" @click="knowledgeActive = false">表格</el-button>
          </el-button-group>
        </div>

        <div v-if="examInfo.hasPaper == 2">
          <div class="inner knowledge-point" v-show="knowledgeActive" v-loading="knowledgeLoading">
            <ul class="list">
              <li class="item" v-for="(item, index) in classKnowPointInfo" :key="index">
                <div class="knowledge-left">
                  <span>{{ item.desc }}</span>
                  <label>{{ item.range }}</label>
                </div>
                <div class="knowledge-center">
                  <ul class="point-list">
                    <li v-for="(point, index) in item.point" :key="'point-' + index">
                      {{ point.pointName }}
                    </li>
                  </ul>
                </div>
                <div class="knowledge-right">{{ item.point.length || 0 }}个</div>
              </li>
            </ul>
          </div>
          <div class="inner" v-show="!knowledgeActive" v-loading="knowledgeLoading">
            <el-table :data="classKnowledgeStat" size="medium" :height="knowTableHeight" border style="width: 100%">
              <el-table-column prop="objectName" align="center" label="知识点">
              </el-table-column>
              <el-table-column prop="weight" width="120px" align="center" sortable label="知识点权重">
              </el-table-column>
              <el-table-column prop="averageRate" width="120px" align="center" sortable label="平均得分率">
              </el-table-column>
              <el-table-column prop="deviation" width="100px" align="center" sortable label="标准差">
              </el-table-column>
              <el-table-column align="center" width="120px" label="对应题号" :render-header="renderHeader">
                <template slot-scope="scope">
                  <join-topic :texts="[scope.row.bigNum, scope.row.smallNum]" :nullText="scope.row.nums" />
                </template>
              </el-table-column>
              <el-table-column align="center" width="100px" label="知识点掌握">
                <template slot-scope="scope">
                  <span :style="{ color: levelStyles[scope.row.levelName] }">{{ scope.row.levelName }}</span>
                </template>
              </el-table-column>
              <el-table-column align="center" width="100px" label="班级对比">
                <template slot-scope="scope">
                  <div class="preview" @click="_compare('KNOWLEDGE_POINT', scope.row)">
                    <img src="~images/preview.png" width="18" />
                    <span>查看</span>
                  </div>
                </template>
              </el-table-column>
            </el-table>
          </div>
        </div>
        <div v-else-if="examInfo.hasPaper == 0">
          <div class="no-data-msg">
            <div>无法关联知识点，请点击下方按钮上传试卷</div>
            <el-upload v-if="!ifHistoryData" :headers="headers" :action="uploadUrl" :show-file-list="false" :on-success="_handleQuestionUploadSuccess" accept=".doc,.docx" :before-upload="beforeAction" :on-error="handleError">
              <el-button type="primary" size="mini">上传试卷</el-button>
            </el-upload>
          </div>
        </div>
        <div v-else="examInfo.hasPaper == 1" style="text-align: center;height: 150px;padding-top: 70px;color:#999">
          <img src="~images/nodata.png" alt="" width="100" />
          <p style="margin-bottom: 20px">暂无数据</p>
        </div>
      </div>
    </div>

    <div class="card">
      <h3>{{ gradeName }}{{ className }}班能力得分情况</h3>

      <div class="card-content">
        <div class="card-button">
          <el-button-group>
            <el-button type="primary" size="medium" :plain="!abilityActive" @click="abilityActive = true">图形</el-button>
            <el-button type="primary" size="medium" :plain="abilityActive" @click="abilityActive = false">表格</el-button>
          </el-button-group>
        </div>

        <div v-if="classAbilityStat.length">
          <div class="inner knowledge-point" v-show="abilityActive" v-loading="abilityLoading">
            <div id="abilityRadar" v-if="classAbilityStat.length > 0"></div>
            <div v-else style="text-align: center;height: 150px;padding-top: 70px;color:#999">
              暂无数据
            </div>
          </div>

          <div class="inner" v-show="!abilityActive" v-loading="abilityLoading">
            <el-table :data="classAbilityStat" size="medium" :height="abilityTableHeight" border style="width: 100%">
              <el-table-column prop="objectName" align="center" label="能力">
              </el-table-column>
              <el-table-column prop="weight" width="120px" align="center" sortable label="能力权重">
              </el-table-column>
              <el-table-column prop="averageRate" width="120px" align="center" sortable label="平均得分率">
              </el-table-column>
              <el-table-column prop="deviation" width="100px" align="center" sortable label="标准差">
              </el-table-column>
              <el-table-column align="center" label="对应题号" :render-header="renderHeader">
                <template slot-scope="scope">
                  <join-topic :texts="[scope.row.bigNum, scope.row.smallNum]" :nullText="scope.row.nums" />
                </template>
              </el-table-column>
              <el-table-column align="center" width="100px" label="能力掌握">
                <template slot-scope="scope">
                  <span :style="{ color: levelStyles[scope.row.levelName] }">{{ scope.row.levelName }}</span>
                </template>
              </el-table-column>
              <el-table-column prop="school_ranking" width="100px" align="center" label="班级对比">
                <template slot-scope="scope">
                  <div class="preview" @click="_compare('QUESTION_ABILITY', scope.row)">
                    <img src="~images/preview.png" width="18" />
                    <span>查看</span>
                  </div>
                </template>
              </el-table-column>
            </el-table>
          </div>
        </div>
        <div v-else style="text-align: center;height: 150px;padding-top: 70px;color:#999">
          <img src="~images/nodata.png" alt="" width="100" />
          <p style="margin-bottom: 20px">暂无数据，请点击添加</p>
          <el-button v-if="!ifHistoryData" type="primary" size="small" round @click="_getPaper">添加</el-button>
        </div>
      </div>
    </div>

    <yue-dialog :title="dialogTitle" :visible.sync="dialogVisible" width="580px" center>
      <div id="compareBar"></div>
    </yue-dialog>
  </div>
</template>

<script>
import { updateSingleExam } from "@/api/exam/exam";
import { classStatCompare } from "@/api/exam/report";
import { classStatCompare_2 } from "@/api/report2";

import echarts from "echarts/lib/echarts";
import radar from "echarts/lib/chart/radar";
import bar from "echarts/lib/chart/bar";
import { echartRadar, echartBar, myEchartBar } from "@/utils/echart";
import { mapGetters } from "vuex";
import { domain } from "@/config";
import JoinTopic from "@/components/JoinTopic";
import { reportApi } from '@/v2/utils/api'
import util from "@/v2/utils/util";

export default {
  props: ["gradeName", "classId", "className", "examInfo", "reportType"],
  components: {
    JoinTopic
  },
  data () {
    return {
      //基础数据
      ifHistoryData: false,
      schoolId: "",
      examId: "",

      dialogTitle: "",
      dialogVisible: false,
      knowledgeActive: true,
      questionActive: true,
      abilityActive: true,

      //loading
      knowledgeLoading: false,
      abilityLoading: false,

      //接收数据的容器
      classKnowPointInfo: [],
      classKnowledgeStat: [],
      classQuestionStat: [],
      classAbilityStat: [],
      gradeAbilityStat: [],
      compareStat: [],

      compareOption: {}, //得分对比图表选项

      knowTableHeight: "auto",
      abilityTableHeight: "auto",
      questionTableHeight: "auto",

      uploadUrl: `${domain}/marking-platform/ossUpload/word2html`,
      msg: null // 当前提示消息对象
    };
  },

  computed: {
    ...mapGetters({
      userInfo: "getUserInfo"
    }),
    headers () {
      return {
        Accept: 'application/json',
        token: YJ_SCHOOL_STORAGE.getItem('token')
      }
    },
    levelStyles () {
      return {
        '非常好': '#1a8fea',
        '很好': '#5abf5f',
        '一般': '#adbdc4',
        '需提高': '#f8b93f',
        '急需提高': '#f64f69'
      };
    }
  },

  mounted () {
    this.ifHistoryData = sessionStorage.getItem("history") == 1 ? true : false;
    this.examId = this.$route.params.id;
    this.schoolId = this.userInfo.schoolId;

    this._initFunc();
  },

  methods: {
    _initFunc () {
      this._classStatistics(1); // 知识点
      this._classStatistics(3); // 能力
    },

    renderHeader (h, { column, $index }) {
      let html = h(
        "el-popover",
        {
          props: {
            placement: "top",
            trigger: "hover",
            content: "蓝色为二卷题号"
          }
        },
        [
          h(
            "i",
            {
              slot: "reference",
              class: "el-icon-question",
              style:
                "color:gray;font-size:16px;margin-left:10px;cursor: pointer;"
            },
            ""
          )
        ]
      );

      if (!this.examInfo.hasTwo) {
        html = "";
      }
      return h("span", {}, [h("span", {}, column.label), html]);
    },

    _compare (type, row) {
      this.dialogTitle = row.objectName + " 得分率班级对比";
      this._classStatCompare(type, row.objectId);
    },

    //获取班级知识点图表信息
    async _classPointInfo () {
      this.knowledgeLoading = true;
      let resp = await reportApi.getPointAnalysis();
      if (resp.success && resp.body) {
        resp.body.forEach(item => {
          item.point = this.classKnowledgeStat.filter(s => s.level === item.kqaLevelEnum).map(s => {
            return {
              num: s.objectId,
              pointName: s.objectName
            }
          })
        })
        this.classKnowPointInfo = resp.body;
      } else {
        this.$message.warning(resp.message);
        this.classKnowPointInfo = [];
      }
      this.knowledgeLoading = false;
    },

    //获取班级各得分情况
    async _classStatistics (type) {
      if (type == 1) this.knowledgeLoading = true; // 知识点
      if (type == 3) this.abilityLoading = true; // 能力

      let params = {
        schoolId: this.schoolId,
        classId: this.classId,
        examId: this.examId,
        type: type === 1 ? 'KNOWLEDGE_POINT' : 'QUESTION_ABILITY'
      };

      let key = this.reportType === 0 ? 'admin' : 'teach'
      let resp = await reportApi.getClassStatistics(key, params)
      if (resp.body && resp.body.length > 0) {
        resp.body.forEach(item => {
          item.nums = item.stands.map(s => { return util.standardQuestionNumber(s) }).join('、')
          item.averageScore = item.averageRate.replace('%', '')
          item.gradeAverageScore = item.preAverageRate.replace('%', '')
        })
      }
      if (resp.success) {
        switch (type) {
          case 1:
            if (resp.body && resp.body.length > 0) {
              this.classKnowledgeStat = resp.body;
              if (this.classKnowledgeStat.length >= 5) {
                this.knowTableHeight = "300";
              }
            }
            this._classPointInfo(); // 知识点图形
            this.knowledgeLoading = false;
            break;

          case 3:
            if (resp.body && resp.body.length > 0) {
              this.classAbilityStat = resp.body;
              if (this.classAbilityStat.length >= 5) {
                this.abilityTableHeight = "300";
              }
            }
            this.abilityLoading = false;
            break;
        }
      }
    },

    //获取班级各得分对比
    async _classStatCompare (type, objectId) {
      let params = {
        schoolId: this.schoolId,
        examId: this.examId,
        objectId: objectId,
        type: type
      };

      let resp;
      if (this.reportType === 0) {
        resp = await classStatCompare(params);
      } else {
        resp = await classStatCompare_2(params);
      }
      if (resp.body) {
        this.compareStat = resp.body;
      }
    },
    //上传试卷
    _handleQuestionUploadSuccess (resp, file, fileList) {
      if (this.msg) {
        this.msg.close();
      }
      const url = resp.body && resp.body.startsWith('http') ? resp.body : null;
      if (!url) {
        const message = resp.body || resp.message || '上传失败，请重试！';
        this.$message({ message, type: "error" });
        return;
      }
      let params = {
        id: this.examId,
        paperName: file.name,
        paperUrl: url,
        hasPaper: 1,
        schoolId: this.schoolId
      };
      this._updateSingleExam(params);
    },

    async _updateSingleExam (params) {
      let resp = await updateSingleExam(params);
      if (resp.success) {
        this.$message.success("上传成功");
        this.$router.go(0);
      }
    },

    beforeAction (file) {
      if (file.size / 1024 / 1024 > 100) {
        this.$message({
          message: "文件大小不能超过100M",
          type: "warning"
        });
        return false;
      }
      let fileName = file.name;
      fileName = fileName.split(".");
      if (
        fileName[fileName.length - 1] != "doc" &&
        fileName[fileName.length - 1] != "docx"
      ) {
        this.$message.warning("只能上传doc或者docx格式文件！");
        return false;
      }

      this.msg = this.$message({
        duration: 0,
        dangerouslyUseHTMLString: true,
        message: '<i class="el-icon-loading"></i>文件上传中，请勿关闭页面',
        type: "warning"
      });
    },

    handleError () { },

    //获取试卷（跳转能力编辑）
    async _getPaper () {
      if (this.examInfo.hasPaper === 0) {
        this.$message.warning("请前往考试列表上传试题卷");
        return;
      }

      if (this.examInfo.hasPaper !== 2 || this.examInfo.hasStand !== 2) {
        this.$message.warning("请先完成切录题");
        return;
      }
      this.$router.push({ path: "/exam/single/report/grade/comment/" + this.examId + "/" + this.classId + "/defaultId/2/edit" });
    },
  }, //methods end

  watch: {
    //切换班级重新获取数据
    classId () {
      this._initFunc();
    },

    //初始化题型图表
    classQuestionStat (val) {
      let param = {};
      let className = this.className;
      let indicator = [];
      let classSeriesValue = [];
      let gradeSeriesValue = [];
      for (let item of this.classQuestionStat) {
        indicator.push({
          name: item.objectName,
          max: 100
        });
        classSeriesValue.push(parseFloat(item.averageScore));
        gradeSeriesValue.push(parseFloat(item.gradeAverageScore));
      }

      param.className = className;
      param.indicator = indicator;
      param.classSeriesValue = classSeriesValue;
      param.gradeSeriesValue = gradeSeriesValue;

      let options = {
        tooltip: {
          formatter: function (resp) {
            let res = "";
            for (let item of val) {
              if (resp.name == "年级") {
                res +=
                  "<p>" + item.objectName + " : " + item.preAverageRate + "</p>";
              } else {
                res += "<p>" + item.objectName + " : " + item.averageRate + "</p>";
              }
            }
            return res;
          }
        },
        legend: {
          data: [param.className, "年级"],
          x: "right",
          y: "bottom",
          orient: "vertical"
        },
        radar: {
          name: {
            textStyle: {
              color: "#94a5bc",
              fontSize: 12
            }
          },
          splitNumber: 3,
          indicator: param.indicator,
          axisLine: {
            // (圆内的几条直线)坐标轴轴线相关设置
            lineStyle: {
              color: "#eff3f9" // 坐标轴线线的颜色。
            }
          },
          splitLine: {
            // (这里是指所有圆环)坐标轴在 grid 区域中的分隔线。
            lineStyle: {
              color: "#eff3f9" // 分隔线颜色
            }
          },
          splitArea: {
            // 坐标轴在 grid 区域中的分隔区域，默认不显示。
            show: true,
            areaStyle: {
              color: ["#b9f3f4", "#daf8f8", "#f2fcfd"] // 图表背景网格的颜色
            }
          }
        },
        series: [
          {
            type: "radar",
            symbol: "circle",
            symbolSize: 8,
            data: [
              {
                value: param.gradeSeriesValue,
                name: "年级",
                itemStyle: {
                  normal: {
                    color: "#f8bb46"
                  }
                }
              },
              {
                value: param.classSeriesValue,
                name: param.className,
                itemStyle: {
                  normal: {
                    color: "#2393eb"
                  }
                }
              }
            ]
          }
        ]
      };
      this.$nextTick(() => {
        let radarChart = echarts.init(document.getElementById("questionRadar"));
        radarChart.setOption(options);
      });
    },

    //初始化能力图表
    classAbilityStat (val) {
      let param = {};
      let className = this.className;
      let indicator = [];
      let classSeriesValue = [];
      let gradeSeriesValue = [];
      for (let item of this.classAbilityStat) {
        indicator.push({
          name: item.objectName,
          max: 100
        });
        classSeriesValue.push(parseFloat(item.averageScore));
        gradeSeriesValue.push(parseFloat(item.gradeAverageScore));
      }

      param.className = className;
      param.indicator = indicator;
      param.classSeriesValue = classSeriesValue;
      param.gradeSeriesValue = gradeSeriesValue;

      let options = {
        tooltip: {
          formatter: function (resp) {
            let res = "";
            for (let item of val) {
              if (resp.name == "年级") {
                res +=
                  "<p>" + item.objectName + " : " + item.preAverageRate + "</p>";
              } else {
                res += "<p>" + item.objectName + " : " + item.averageRate + "</p>";
              }
            }
            return res;
          }
        },
        legend: {
          data: [param.className, "年级"],
          x: "right",
          y: "bottom",
          orient: "vertical"
        },
        radar: {
          name: {
            textStyle: {
              color: "#94a5bc",
              fontSize: 12
            }
          },
          splitNumber: 3,
          indicator: param.indicator,
          axisLine: {
            // (圆内的几条直线)坐标轴轴线相关设置
            lineStyle: {
              color: "#eff3f9" // 坐标轴线线的颜色。
            }
          },
          splitLine: {
            // (这里是指所有圆环)坐标轴在 grid 区域中的分隔线。
            lineStyle: {
              color: "#eff3f9" // 分隔线颜色
            }
          },
          splitArea: {
            // 坐标轴在 grid 区域中的分隔区域，默认不显示。
            show: true,
            areaStyle: {
              color: ["#b9f3f4", "#daf8f8", "#f2fcfd"] // 图表背景网格的颜色
            }
          }
        },
        series: [
          {
            type: "radar",
            symbol: "circle",
            symbolSize: 8,
            data: [
              {
                value: param.gradeSeriesValue,
                name: "年级",
                itemStyle: {
                  normal: {
                    color: "#f8bb46"
                  }
                }
              },
              {
                value: param.classSeriesValue,
                name: param.className,
                itemStyle: {
                  normal: {
                    color: "#2393eb"
                  }
                }
              }
            ]
          }
        ]
      };
      this.$nextTick(() => {
        let radarChart = echarts.init(document.getElementById("abilityRadar"));
        radarChart.setOption(options);
      });
    },

    //初始化得分对比图表(点击右侧查看)
    compareStat (val) {
      this.dialogVisible = true;
      let option = {};
      option.legendData = ["班级", "年级", "联考"];
      option.xAxisData = [];
      option.data = [];
      option.series = [];
      let series = {
        name: "班级",
        data: [],
        markLine: {
          data: [
            {
              name: "年级",
              yAxis: val.current.scoreRate * 100,
              label: {
                normal: {
                  position: "middle",
                  formatter: "{b} : {c}"
                }
              },
              lineStyle: {
                normal: {
                  type: "solid",
                  color: "#f9c157"
                }
              }
            }
          ]
        }
      };
      for (let item of val.subOrg) {
        option.xAxisData.push(item.orgName);
        const value = +(parseFloat(item.scoreRate) * 100).toFixed(2);
        series.data.push(value);
      }
      option.series.push(series);
      this.$nextTick(() => {
        myEchartBar(option, "compareBar");
      });
    },

    //计算题号-知识点得分情况表格
    classKnowledgeStat (val) {
      for (let item of val) {
        item.weight = parseFloat(item.weight);
        item.averageScore = parseFloat(item.averageScore);
      }
      this.getNums(val);
    }
  }
};
</script>

<style scoped lang="scss">
#questionRadar,
#abilityRadar {
  width: 100%;
  height: 300px;
}

#compareBar {
  width: 100%;
  height: 300px;
}

.preview {
  color: $color-theme;
  cursor: pointer;

  img {
    vertical-align: middle;
    margin-top: -2px;
  }

  span {
    padding: 0 5px;
  }
}

.wrapper {
  flex: 1;
  width: 0;
  box-sizing: border-box;
  margin-top: 14px;

  .card {
    flex: 1;
    border-radius: 4px;
    background: #fff;
    box-shadow: $box-shadow;
    padding-bottom: 10px;
    margin-bottom: 20px;

    > h3 {
      padding: 0 10px;
      height: 40px;
      line-height: 44px;
      font-size: 16px;
      color: $color-text;

      &:before {
        margin-top: -4px;
        display: inline-block;
        content: "";
        width: 4px;
        height: 20px;
        vertical-align: middle;
        background: $color-theme;
        border-radius: 10px;
        margin-right: 10px;
      }

      span {
        padding-left: 20px;
        font-size: $font-size-small;
        color: #aaa;
      }

      .button-group {
        display: inline-block;
        float: right;
      }
    }

    .card-content {
      padding: 0 35px 20px;

      .card-button {
        display: flex;
        justify-content: center;

        .el-button-group .el-button:first-child {
          border-radius: 20px 0 0 20px;
        }

        .el-button-group .el-button:last-child {
          border-radius: 0 20px 20px 0;
        }
      }

      .inner {
        padding-top: 20px;
        min-height: 325px;
        box-sizing: border-box;

        .more-data {
          height: 40px;
          line-height: 40px;
          text-align: center;
          font-size: 14px;
        }

        .list {
          .item {
            &:nth-child(1) .knowledge-center {
              background: #e6f3fe;
            }

            &:nth-child(1) .knowledge-center:before {
              background: #1a8fea;
            }

            &:nth-child(1) .knowledge-center .point-list li {
              color: #1a8fea;
              background: #c2e1fb;
            }

            &:nth-child(2) .knowledge-center {
              background: #e7fce8;
            }

            &:nth-child(2) .knowledge-center:before {
              background: #5abf5f;
            }

            &:nth-child(2) .knowledge-center .point-list li {
              color: #5abf5f;
              background: #c9f3cb;
            }

            &:nth-child(3) .knowledge-center {
              background: #e9eff2;
            }

            &:nth-child(3) .knowledge-center:before {
              background: #adbdc4;
            }

            &:nth-child(3) .knowledge-center .point-list li {
              color: #adbdc4;
              background: #d5dfe7;
            }

            &:nth-child(4) .knowledge-center {
              background: #faede1;
            }

            &:nth-child(4) .knowledge-center:before {
              background: #f8b93f;
            }

            &:nth-child(4) .knowledge-center .point-list li {
              color: #cf9e71;
              background: #f4dcc6;
            }

            &:nth-child(5) .knowledge-center {
              background: #fee6ee;
            }

            &:nth-child(5) .knowledge-center:before {
              background: #f64f69;
            }

            &:nth-child(5) .knowledge-center .point-list li {
              color: #f64f69;
              background: #f9cedc;
            }

            display: flex;
            margin-bottom: 4px;
            justify-content: center;
            align-items: center;

            .knowledge-left {
              width: 80px;
              text-align: center;

              span {
                display: block;
                padding-bottom: 6px;
                font-size: $font-size;
                color: #333;
              }

              label {
                font-size: $font-size-small;
                color: #777;
              }
            }

            .knowledge-center {
              flex: 1;
              position: relative;

              &:before {
                position: absolute;
                left: 0;
                top: 0;
                bottom: 0;
                content: "";
                display: block;
                width: 3px;
              }

              .point-list {
                padding: 6px 10px;
                min-height: 34px;

                > li {
                  display: inline-block;
                  margin: 5px;
                  font-size: $font-size-small;
                  border-radius: 20px;
                  padding: 6px 13px;
                }
              }
            }

            .knowledge-right {
              width: 60px;
              color: #777;
              text-align: center;
              font-size: 14px;
            }
          }
        }
      }
    }
  }

  .no-data-msg {
    text-align: center;
    height: 150px;
    padding-top: 70px;
    color: #999;

    .el-button {
      margin-top: 40px;
      border-radius: 20px;
    }
  }
}

.active {
  background-color: $color-theme;
  color: #fff;
}
</style>
